import { render, staticRenderFns } from "./jiading.vue?vue&type=template&id=209e4038&scoped=true&"
import script from "./jiading.vue?vue&type=script&lang=js&"
export * from "./jiading.vue?vue&type=script&lang=js&"
import style0 from "./jiading.vue?vue&type=style&index=0&id=209e4038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209e4038",
  null
  
)

export default component.exports